import {
    IDENTITY_DOCUMENT,
    LOADED_IDENTITY_DOCUMENT,
    LOADING_IDENTITY_DOCUMENT,
    SCHEME_IDENTITY_DOCUMENT,
} from '../store/actionTypes';

export const schemeIdentityDocument = (state = {}, action) => {
    switch (action.type) {
        case SCHEME_IDENTITY_DOCUMENT:
            return action.object;
        default:
            return state;
    }
};
export const identityDocument = (state = {}, action) => {
    switch (action.type) {
        case IDENTITY_DOCUMENT:
            return action.object;
        default:
            return state;
    }
};
export const loadingIdentityDocument = (state = false, action) => {
    switch (action.type) {
        case LOADING_IDENTITY_DOCUMENT:
            return action.status;
        default:
            return state;
    }
};
export const loadedIdentityDocument = (state = false, action) => {
    switch (action.type) {
        case LOADED_IDENTITY_DOCUMENT:
            return action.status;
        default:
            return state;
    }
};
